import { SVGProps, Ref, forwardRef } from 'react';

export const ClockFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 1.333C5 1.333 1.333 8.667 1.333 16S5 30.667 16 30.667 30.667 23.333 30.667 16 27 1.333 16 1.333m1.2 6.134h-2.4v9.24l7.666 4.258 1.166-2.098-6.432-3.573z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ClockFilledSize32Glyph.displayName = 'ClockFilledSize32Glyph';
